import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Item = styled.div`
  padding: 5px;
  position: relative;

  &.small {
    padding: 3px;

    .id {
      top: auto;
      bottom: 5px;
    }
  }
`;

export const Icon = styled.div`
  position: absolute;
  top: 15px;
  right: 10px;
`;

export const Id = styled.div`
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 999;
  opacity: 0.4;
  font-size: 11px;
`;
